import { Injectable } from '@angular/core';
import { HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { 
  ODataClient,
  ODataEntityService, 
  ODataEntity, 
  ODataEntities, 
  ODataProperty, 
  EntityKey,
  Duration,
  ODataEntityResource,
  ODataEntitySetResource,
  ODataNavigationPropertyResource,
  ODataActionResource,
  ODataFunctionResource,
  HttpOptions
} from 'angular-odata';

//#region ODataApi Imports
import { Aktie } from '../entities/boerse/aktie.entity';
import { Analyst } from '../entities/boerse/analyst.entity';
import { Kursziel } from '../entities/boerse/kursziel.entity';
//#endregion

@Injectable()
export class KurszielService extends ODataEntityService<Kursziel> {
  constructor(protected client: ODataClient) {
    super(client, 'Kursziel', 'entities.boerse.Kursziel');
  }

  
  
  //#region ODataApi Actions
  //#endregion
  //#region ODataApi Functions
  //#endregion
  //#region ODataApi Navigations
  public aktie(entity: EntityKey<Kursziel>): ODataNavigationPropertyResource<Aktie> {
    return this.entity(entity).navigationProperty<Aktie>('aktie');
  }
  public analyst(entity: EntityKey<Kursziel>): ODataNavigationPropertyResource<Analyst> {
    return this.entity(entity).navigationProperty<Analyst>('analyst');
  }
  //#endregion
}
